import React, { Component } from 'react';
import { connect } from 'react-redux';

import
  SummaryShareContributeComponent
from '../../../components/purchase-dashboard/group-summary/summary-share.contribute';
import {
  getCurrentPurchase,
} from '../../../selectors/purchase-selector';
import Purchase from '../../../lib/purchase';
import {
  showCommitModal,
  hideAlert,
  SHARED_NAMESPACE,
  ALERT_WITHDRAW_FROM_PURCHASE
} from '../../../actions';

class SummaryShareContribute extends Component {
  onCommit = () => {
    const { showCommitModal, hideAlert } = this.props;
    hideAlert(ALERT_WITHDRAW_FROM_PURCHASE);
    showCommitModal();
  }

  disableContributions = () => {
    const { commitDeadline, dueDeadline, isPurchaseActive, isPurchaseFull, isPurchaseCompleted } = this.props;
    if (!isPurchaseActive || isPurchaseFull || isPurchaseCompleted) return true;
    if (Purchase.isDateExpired(dueDeadline)) return true;
    if (Purchase.isDateExpired(commitDeadline)) return true;

    return false;
  }

  render() {
    return (
      <SummaryShareContributeComponent
        membership={this.props.membership}
        costType={this.props.costType}
        costRange={this.props.costRange}
        splitType={this.props.splitType}
        currentProductCostAmount={this.props.currentProductCostAmount}
        disabled={this.disableContributions()}
        full={this.props.isPurchaseFull}
        completed={this.props.isPurchaseCompleted}
        minContribution={this.props.minContribution}
        onCommit={this.onCommit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const completed = Purchase.isCompleted(purchase);
  let membership;

  if (state.projections[SHARED_NAMESPACE]) {
    membership = state.projections[SHARED_NAMESPACE].memberships[state.memberships.current];
  }

  return {
    membership,
    minContribution: purchase.group.minContribution,
    costRange: purchase.costRange,
    costType: purchase.product.costType,
    splitType: purchase.group.splitType,
    currentProductCostAmount: purchase.currentProductCostAmount,
    commitDeadline: purchase.group.commitDeadline,
    dueDeadline: purchase.nextPaymentDueDeadline,
    isPurchaseActive: Purchase.isActive(purchase.status),
    isPurchaseFull: Purchase.isGroupFull(purchase),
    isPurchaseCompleted: completed,
  };
};

const mapDispatchToProps = {
  showCommitModal,
  hideAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryShareContribute);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/group-summary/summary-share-contribute.container.js